import { render, staticRenderFns } from "./BulkJobCreate.vue?vue&type=template&id=5e3e3c70&scoped=true&"
import script from "./BulkJobCreate.vue?vue&type=script&lang=ts&"
export * from "./BulkJobCreate.vue?vue&type=script&lang=ts&"
import style0 from "./BulkJobCreate.vue?vue&type=style&index=0&id=5e3e3c70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e3c70",
  null
  
)

export default component.exports